import { MealName, recipeInfo } from '@marketing/content';
var allMealProductCardData = {};
Object.keys(recipeInfo).forEach(function (key) {
    allMealProductCardData[key] = {
        productDetails: {
            productName: recipeInfo[key].displayName,
            priceLevel: recipeInfo[key].priceLevel,
            price: recipeInfo[key].price,
            productId: recipeInfo[key].productId,
            isActive: recipeInfo[key].isActive,
            ingredients: recipeInfo[key].ingredients,
            pageUrl: recipeInfo[key].url,
        },
        isNew: recipeInfo[key].isNew,
        imageData: recipeInfo[key].image,
    };
});
export var mealsProductListingContent = {
    title: 'Meals as Stimulating as Spare Socks',
    productCardData: [
        allMealProductCardData[MealName.TurkeyChicken],
        allMealProductCardData[MealName.Lamb],
        allMealProductCardData[MealName.Turkey],
        allMealProductCardData[MealName.Beef],
        allMealProductCardData[MealName.Chicken],
        allMealProductCardData[MealName.Pork],
        allMealProductCardData[MealName.SamplerPack],
    ],
};
